import {
  Card,
  CardHeader,
  createTheme,
  Grid,
  IconButton,
  Skeleton,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableFooter,
  TableRow,
  Tooltip,
  Typography,
} from "@material-ui/core";
import PropTypes from "prop-types";
import { TablaHead, TablaToolbar } from "../_dashboard/tablas";
import Scrollbar from "../Scrollbar";
import {
  capitalizarPalabras,
  capitalizarPrimeraLetra,
} from "src/utils/sharedFunctions";
import SearchNotFound from "../SearchNotFound";
import { ThemeProvider } from "@material-ui/styles";
import * as locales from "@material-ui/core/locale";
import CustomTablePagination from "../CustomTablePagination";
import { useMemo, useState } from "react";
import { applySortFilter, getComparator } from "src/utils/sharedTables";
import dayjs from "dayjs";
import "dayjs/locale/es.js";
import { Visibility } from "@material-ui/icons";
import { useNavigate } from "react-router-dom";

dayjs.locale("es");

AppTablaTareasEmpleado.propTypes = {
  data: PropTypes.array,
  loadingData: PropTypes.bool,
};

export default function AppTablaTareasEmpleado({
  title,
  subheader,
  data,
  loadingData,
}) {
  const [statesTable, setStatesTable] = useState(INITIAL_STATE_TABLE);
  const navigate = useNavigate();

  const handleFilterByName = (event) => {
    setStatesTable({ ...statesTable, filterName: event.target.value });
  };

  const handleRequestSort = (event, property) => {
    const isAsc =
      statesTable.orderBy === property && statesTable.order === "asc";
    setStatesTable({
      ...statesTable,
      order: isAsc ? "desc" : "asc",
      orderBy: property,
    });
  };

  const handleChangePage = (event, newPage) => {
    setStatesTable({ ...statesTable, currentPage: newPage });
  };

  const handleChangeRowsPerPage = (event) => {
    setStatesTable({
      ...statesTable,
      rowsPerPageOptions: Number(event.target.value),
      currentPage: 0,
    });
  };

  const dataFiltrada = useMemo(() => {
    const propiedadesParaFiltrar = [
      "nombre",
      "nombreCliente",
      "nombreEmpleado",
      "apellidosEmpleado",
      "tipoTarea",
    ];
    return applySortFilter(
      data,
      getComparator(statesTable.order, statesTable.orderBy),
      statesTable.filterName,
      propiedadesParaFiltrar,
    );
  }, [data, statesTable.filterName, statesTable.order, statesTable.orderBy]);

  const filasVacias =
    statesTable.currentPage > 0
      ? Math.max(
          0,
          (1 + statesTable.currentPage) * statesTable.rowsPerPageOptions -
            data.length,
        )
      : 0;

  const seEncontroElemento = dataFiltrada.length === 0;

  const handleClickWatchTask = (id) => {
    navigate("/dashboard/tareas/" + id);
  };

  return (
    <Card sx={{ height: "100%" }}>
      <Grid
        container
        direction="column"
        justifyContent="flex-start"
        alignItems="stretch"
        sx={{ height: "100%" }}
      >
        <Grid item>
          <Grid container>
            <Grid item xs={12} md={6} lg={6}>
              <CardHeader title={title} subheader={subheader} />
            </Grid>
            <Grid item xs={12} md={6} lg={6}>
              <Grid container justifyContent="flex-end" alignItems="center">
                <Grid item></Grid>
                <Grid
                  item
                  sx={{
                    display: "flex",
                    justifyContent: "flex-end",
                    alignItems: "center",
                  }}
                  xs={12}
                  md={8}
                  lg={8}
                >
                  <TablaToolbar
                    filterName={statesTable.filterName}
                    onFilterName={handleFilterByName}
                  />
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
        <Grid item>
          <Scrollbar>
            <TableContainer>
              {!loadingData ? (
                <Table>
                  <TablaHead
                    order={statesTable.order}
                    orderBy={statesTable.orderBy}
                    headLabel={TABLE_HEAD}
                    rowCount={data.length}
                    onRequestSort={handleRequestSort}
                  />
                  <TableBody>
                    {dataFiltrada
                      .slice(
                        statesTable.currentPage *
                          statesTable.rowsPerPageOptions,
                        statesTable.currentPage *
                          statesTable.rowsPerPageOptions +
                          statesTable.rowsPerPageOptions,
                      )
                      .map((elemento, index) => (
                        <TableRow hover key={elemento.id}>
                          <TableCell>
                            {statesTable.currentPage *
                              statesTable.rowsPerPageOptions +
                              index +
                              1}
                          </TableCell>
                          <TableCell>
                            <Typography variant="subtitle2" noWrap>
                              {capitalizarPrimeraLetra(elemento.nombre)}
                            </Typography>
                          </TableCell>
                          <TableCell>
                            {capitalizarPrimeraLetra(elemento.tipoTarea)}
                          </TableCell>
                          <TableCell>
                            {capitalizarPrimeraLetra(elemento.estado)}
                          </TableCell>
                          <TableCell>
                            {capitalizarPalabras(elemento.nombreCliente)}
                          </TableCell>
                          <TableCell>{elemento.complejidadCliente}</TableCell>
                          <TableCell>
                            {dayjs(elemento.fechaInicio).format("DD/MM/YYYY")}
                          </TableCell>
                          <TableCell>
                            {elemento.fechaTermino
                              ? dayjs(elemento.fechaTermino).format(
                                  "DD/MM/YYYY",
                                )
                              : ""}
                          </TableCell>
                          <TableCell>
                            {capitalizarPalabras(
                              `${elemento.nombreEmpleado} ${elemento.apellidosEmpleado}`,
                            )}
                          </TableCell>
                          <TableCell>
                            {capitalizarPrimeraLetra(elemento.sucursal)}
                          </TableCell>
                          <TableCell>
                            <Tooltip title="Ver tarea">
                              <IconButton
                                color="primary"
                                onClick={() =>
                                  handleClickWatchTask(elemento.id)
                                }
                                aria-label="watch-task"
                                size="small"
                              >
                                <Visibility />
                              </IconButton>
                            </Tooltip>
                          </TableCell>
                        </TableRow>
                      ))}

                    {filasVacias > 0 && (
                      <TableRow style={{ height: 53 * filasVacias }}>
                        <TableCell colSpan={3} />
                      </TableRow>
                    )}
                  </TableBody>
                  {seEncontroElemento && (
                    <TableBody>
                      <TableRow>
                        <TableCell align="center" colSpan={10} sx={{ py: 3 }}>
                          <SearchNotFound
                            searchQuery={statesTable.filterName}
                          />
                        </TableCell>
                      </TableRow>
                    </TableBody>
                  )}
                  <TableFooter>
                    <TableRow>
                      <ThemeProvider
                        theme={(outerTheme) =>
                          createTheme(outerTheme, locales[statesTable.locale])
                        }
                      >
                        <CustomTablePagination
                          count={dataFiltrada.length}
                          rowsPerPage={statesTable.rowsPerPageOptions}
                          page={statesTable.currentPage}
                          colSpan={10}
                          onPageChange={handleChangePage}
                          onRowsPerPageChange={handleChangeRowsPerPage}
                        />
                      </ThemeProvider>
                    </TableRow>
                  </TableFooter>
                </Table>
              ) : (
                <Skeleton variant="rectangular" width="100%" height="500px" />
              )}
            </TableContainer>
          </Scrollbar>
        </Grid>
      </Grid>
    </Card>
  );
}

const TABLE_HEAD = [
  { id: "position", label: "N°", alignRight: false },
  { id: "nombre", label: "Tarea", alignRight: false },
  { id: "tipoTarea", label: "Tipo tarea", alignRight: false },
  { id: "estado", label: "Estado", alignRight: false },
  { id: "nombreCliente", label: "Cliente", alignRight: false },
  { id: "complejidadCliente", label: "Complejidad", alignRight: false },
  { id: "fechaInicio", label: "Fecha inicio", alignRight: false },
  { id: "fechaTermino", label: "Fecha término", alignRight: false },
  { id: "nombreEmpleado", label: "Empleado", alignRight: false },
  { id: "sucursal", label: "Sucursal", alignRight: false },
  { id: "ver-tarea", label: "", alignRight: true },
];

const INITIAL_STATE_TABLE = {
  currentPage: 0,
  rowsPerPageOptions: 5,
  order: "desc",
  orderBy: "fechaInicio",
  locale: "esES",
  filterName: "",
};
